import React, { FC, useCallback, useEffect } from 'react';

import { useServerLocale } from 'src/app/i18n';
import { useRequest } from 'ahooks';

import { useTranslation } from 'src/app/common/hooks/translation.hook';
import { useHistory, useParams } from 'react-router-dom';
import { fetchApplicationList } from '../../network/applicationCrud';

export const useDetail = () => {
  const { t } = useTranslation();
  const locale = useServerLocale(true);
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  // redux
  // const dispatch = useDispatch();
  // const saleskit = useSelector<RootState>((state) => state.saleskit);
  // useRequest to wrap api request.
  // DO NOT use useDataProvider except for <PruFilter />
  const { data, error, loading, run, runAsync } = useRequest(
    (objectId) => {
      const condition = window.localStorage.getItem('jwt') ? 'OWN' : 'PUBLIC';
      return fetchApplicationList(condition, {
        id: objectId,
        name: '',
        role: '',
        bundleIdentifier: '',
        lang: locale,
      });
    },
    { manual: true },
  );

  useEffect(() => {
    if (id) {
      // manual call api request
      run(id);
    }
  }, []);

  const onLogout = () => {
    history.push(`/logout`);
  };

  return {
    loading,
    data,
    error,
    run,
    onLogout,
  };
};
